const faSignal = {
  prefix: 'fal',
  iconName: 'signal',
  icon: [
    448,
    512,
    [128246, 'signal-5', 'signal-perfect'],
    'f012',
    'M448 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416zM328 128c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16s16-7.2 16-16l0-320c0-8.8-7.2-16-16-16zM240 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224zM120 320c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zM16 384c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z',
  ],
};
export default faSignal;
